import { SpDropdownToggle } from 'components/shared/Dropdown';
import { useCallback, useState } from 'react';
import { DropdownDivider, DropdownItem, DropdownMenu } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import { FormattedMessage } from 'react-intl';
import { useSearchType } from 'routes/secondary-market-batch/hooks/use-search-type';
import { useSwitchOrderSearchType } from 'routes/secondary-market-batch/hooks/use-switch-order-search-type';
import { toIntlKey } from 'routes/secondary-market-batch/utils';
import { SearchType } from 'state/workspaces/secondary-market/batch/model';

import { useSearchCodeTypesItems } from './hooks';

type Props = { codeType: SearchType };
function CodeTypeItem({ codeType }: Props) {
  const switchOrderSearchType = useSwitchOrderSearchType();
  return (
    <DropdownItem onClick={_ => switchOrderSearchType(codeType)}>
      <FormattedMessage id={toIntlKey(codeType)} />
    </DropdownItem>
  );
}

export function CodeTypeSelector() {
  const { primaryItems, extendedItems, isReadonly, isEmpty } = useSearchCodeTypesItems();
  const [isOpened, setIsOpened] = useState(false);
  const searchType = useSearchType();
  const toggle = useCallback(() => {
    if (!isReadonly) {
      setIsOpened(old => !old);
    }
  }, [isReadonly]);

  if (isEmpty) {
    return null;
  }

  return !isReadonly ? (
    <Dropdown show={isOpened && !isReadonly} onToggle={toggle} drop="down" className="readonly">
      <SpDropdownToggle variant="secondary" caret={!isReadonly}>
        <span data-e2e="search-type-dropdown-btn" className="text-uppercase">
          <FormattedMessage id={toIntlKey(searchType)} />
        </span>
      </SpDropdownToggle>

      <DropdownMenu>
        {primaryItems.map(codeType => (
          <CodeTypeItem key={codeType.source} codeType={codeType} />
        ))}
        <DropdownDivider />
        {extendedItems.map(codeType => (
          <CodeTypeItem key={codeType.source} codeType={codeType} />
        ))}
      </DropdownMenu>
    </Dropdown>
  ) : (
    <div className="d-flex h-100 bg-secondary align-items-center">
      <span data-e2e="search-type-dropdown-btn" className="text-uppercase btn no-hover">
        <FormattedMessage id={toIntlKey(searchType)} />
      </span>
    </div>
  );
}
